<template>
  <div id="new-layout">
    <div id="main-nav">
      <NavBarRevamp v-if="$route.path === '/' || $route.path.includes('/parcelpreneur')" />
      <NewNavBar v-else />
    </div>
    <div
      id="app-router-view"
      :style="styleApp"
    >
      <router-view />
    </div>
    <!-- whatsapp for customer service  -->
    <div id="floating-items">
      <div class="wrapper-liona">
        <a
          id="wa-cs-new"
          href="https://wa.me/6281119561000"
          rel="noreferrer noopener"
          target="_blank"
          :class="setLionaClass"
        >
          <ImageLazy
            v-if="showLiona"
            id="Liona"
            :src="Liona"
            alt="whatsapp_liona"
            width="100%"
            height="100%"
          />
        </a>
      </div>
    </div>
    <div class="footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import NewNavBar from "@/components/new-navbar/NewNavbar";
import NavBarRevamp from "@/components/new-navbar/NavbarRevamp";
import Footer from "@/components/new-footer/v2/Footer";
import Liona from "@/assets/Liona.webp";
import ImageLazy from '@/components/ImageLazy/index.vue';
import mixinLayout from '../misc/mixinLayout';

export default {
  name: "NewLayout",
  components: {
    Footer,
    NewNavBar,
    NavBarRevamp,
    ImageLazy,
  },
  mixins: [mixinLayout],
  data() {
    return {
      Liona,
    };
  },
  computed: {
    styleApp() {
      return  {
        position: "",
        paddingTop: (this.$route.path === "/" || this.$route.path.includes('/parcelpreneur')) ? "" : "36px",
      }
    },
    showLiona() {
      const exclude = [''];
      return !exclude.includes(this.$route.path)
    },
    setLionaClass() {
      const include = ['/agen'];
      return !include.includes(this.$route.path) ? 'bottom0' : ''
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/reset.scss";
@import "@/assets/css/style.scss";

#new-layout {
  font-family: "Inter", sans-serif;
}

#container-app {
  box-sizing: border-box;
  padding: 0;
  margin: 0 auto;
}

#main-nav {
  height: 0;
  position: fixed;
  width: 100%;
  z-index: 1001;
}

#floating-items {
  position: fixed;
  right: 0 !important;
  padding-right: 10px;
  z-index: 10;

  .wrapper-liona {
    #wa-cs-new {
      position: fixed;
      right: 0 !important;
      bottom: 22%;
      padding-right: 10px;
      z-index: 10;
      cursor: pointer;
      transition: all ease-in-out 0.3s;
      width: 150px;

      @include for-size(mobile) {
        width: 80px;
        bottom: 20%;
      }

      @include for-size(mobile-landscape) {
        width: 80px;
        bottom: 36%;
      }

      @include for-size(tablet-portrait) {
        bottom: 16%;
      }

      &:hover {
        transform: scale(1.05);
      }
    }
  }
}

.footer {
  display: flex;
  justify-content: center;
}

::v-deep ::placeholder {
  font-family: "Inter", sans-serif;
}

.bottom0 {
  bottom: 0 !important;
}
</style>
